<template>
  <material-card color="dover-blue">
    <div>
      <v-flex
        xs12
        md12>
        <material-card
          :title="title"
          :text="subTitle"
          color="dover-blue">
          <div>
            <v-flex
              xs6
              md2>
              <MaglinkComponentTankList
                :loading="false"
                :filters="filters"
                :tanks="csldTanks" />
            </v-flex>
            <v-flex
              xs6
              md10/>
            <v-flex
              xs12
              md12>
              <v-tabs
                fixed-tabs
                color="dover-blue"
                slider-color="yellow"
                dark
                icons-and-text>
                <v-tab
                  :key="0"
                  ripple>
                  {{ $t('Current Test') }}
                </v-tab>
                <v-tab-item
                  :key="0">
                  <MaglinkReportCsldLeakTestsCurrent
                    :system-settings="systemSettings"
                    :options="options"
                    :csld-reason-code="csldReasonCode"
                    :csld-reason-desc="csldReasonDesc"
                    :tank="tank"
                    :counters="counters" />
                </v-tab-item>

                <v-tab
                  :key="1"
                  ripple>
                  {{ $t('History') }}
                </v-tab>
                <v-tab-item
                  :key="1">
                  <MaglinkReportCsldLeakTestsHistory
                    :tanks="csldTanks"
                    :filters="filters"
                    :system-settings="systemSettings"
                    :site-info="siteInfo"
                    :options="options"
                    :csld-reason-desc="csldReasonDesc" />
                </v-tab-item>

                <v-tab
                  :key="2"
                  ripple>
                  {{ $t('Daily report') }}
                </v-tab>
                <v-tab-item
                  :key="2">
                  <MaglinkReportCsldLeakTestsDaily
                    :tanks="csldTanks"
                    :filters="filters"
                    :system-settings="systemSettings"
                    :site-info="siteInfo"
                    :options="options"
                    :csld-reason-desc="csldReasonDesc"/>
                </v-tab-item>

                <v-tab
                  :key="3"
                  ripple>
                  {{ $t('Diagnostics') }}
                </v-tab>
                <v-tab-item
                  :key="3">
                  <MaglinkReportCsldLeakTestsDiagnostics
                    :system-settings="systemSettings"
                    :options="options"
                    :csld-reason-code="csldReasonCode"
                    :csld-reason-desc="csldReasonDesc"
                    :tank="tank"
                    :counters="counters" />
                </v-tab-item>

                <v-tab
                  :key="4"
                  ripple>
                  {{ $t('Segments') }}
                </v-tab>
                <v-tab-item
                  :key="4">
                  <MaglinkReportCsldLeakTestsSegments
                    :tanks="csldTanks"
                    :filters="filters"
                    :system-settings="systemSettings"
                    :site-info="siteInfo"
                    :options="options"
                    :csld-reason-desc="csldReasonDesc" />
                </v-tab-item>

              </v-tabs>
            </v-flex>
          </div>
        </material-card>
      </v-flex>
    </div>
  </material-card>
</template>

<script>

export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => { }
    },
    options: {
      type: Object,
      required: true,
      default: () => { }
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => { }
    }
  },
  data: () => ({
    isValidationOk: false,
    filters: {
      all: false,
      number: 1,
      type: 0,
      fromDay: '',
      toDay: ''
    },
    currentTank: 0,
    csldReasonCode: [],
    csldReasonDesc: [],
    csldTanks: [],
    tank: {},
    counters: {
      passedTests: 0,
      lastPassed: 0,
      leakDetected: 0,
      lastLeak: 0,
      inconclusive: 0,
      lastInconclusive: 0,
      highLeakRate: 0,
      lastHighLeakRate: 0,
      productGain: 0,
      lastProductGain: 0,
      insufficientData: 0,
      lastInsufficientData: 0,
      highTemperature: 0,
      lastHighTemperature: 0,
      bottomTemperature: 0,
      lastBottomTemperature: 0,
      tempNoise: 0,
      lastTempNoise: 0,
      heightNoise: 0,
      lastHeightNoise: 0,
      thermalExpansion: 0,
      lastTermalExpansion: 0,
      heightDifferential: 0,
      lastHeightDifferential: 0,
      manifoldBroken: 0,
      lastManifoldBroken: 0,
      jumpCounter: 0,
      lastJumpCounter: 0,
      notEnoughSegments: 0,
      lastNotEnoughSegments: 0
    },
    title: 'CSLD',
    subTitle: ''
  }),
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        if (newVal !== undefined) {
          if (newVal.number !== this.currentTank) {
            this.currentTank = newVal.number

            this.Maglink.GetTankStatus(this.currentTank)
              .then(response => {
                this.tank = response.data

                let tResult = this.$t('CSLD')
                let result = this.$t('Height') + ' - ' + this.$t('Max volume') + ' -'
                if (this.tank !== undefined) {
                  tResult += ' - ' + this.tank.tankDescription
                  result = this.$t('Height') + ' (' + this.Maglink.LevelFormat(this.tank.maxLevel, this.systemSettings.levelUnit) + ')'
                  result += ' ' + this.options.levelUnits[this.systemSettings.levelUnit || 0].desc + ' - '
                  result += this.$t('Max volume') + ' (' + this.Maglink.VolumeFormat(this.tank.maxVolume, this.systemSettings.volumeUnit) + ')'
                  result += ' ' + this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
                  if (this.tank.tankGroup !== 0) {
                    result += ' - ' + this.$t('Member of group {0}', [this.tank.tankGroup])
                  }
                }

                this.title = tResult
                this.subTitle = result
              })
              .catch(error => {
                this.snack('error', error.message)
              })

            this.Maglink.GetCsldCounters(this.currentTank)
              .then(response => {
                this.counters = response.data
              })
              .catch(error => {
                this.snack('error', error.message)
              })
          }
        }
      }
    },
    tanks: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        if (newVal === undefined) {
          this.tanks = []
        }

        this.csldTanks = newVal.filter(t => t.autoLeakTestType === 2)
      }
    }
  },
  mounted () {
    var currentDate = new Date()
    this.filters.toDay = currentDate.toISOString().substr(0, 10)

    currentDate.setDate(currentDate.getDate() - 7)

    this.filters.fromDay = currentDate.toISOString().substr(0, 10)

    this.csldReasonCode[0] = this.$t('P')
    this.csldReasonCode[1] = this.$t('F')
    this.csldReasonCode[2] = this.$t('Code').toUpperCase() + ' 2'
    this.csldReasonCode[3] = this.$t('LV')
    this.csldReasonCode[4] = this.$t('Code').toUpperCase() + ' 4'
    this.csldReasonCode[5] = this.$t('Code').toUpperCase() + ' 5'
    this.csldReasonCode[6] = this.$t('Code').toUpperCase() + ' 6'
    this.csldReasonCode[7] = this.$t('Code').toUpperCase() + ' 7'
    this.csldReasonCode[8] = this.$t('I5')
    this.csldReasonCode[9] = this.$t('Code').toUpperCase() + ' 9'
    this.csldReasonCode[10] = this.$t('Code').toUpperCase() + ' 10'
    this.csldReasonCode[11] = this.$t('I1')
    this.csldReasonCode[12] = this.$t('MR')
    this.csldReasonCode[13] = this.$t('TN')
    this.csldReasonCode[14] = this.$t('HN')
    this.csldReasonCode[15] = this.$t('TE')
    this.csldReasonCode[16] = this.$t('I8')
    this.csldReasonCode[17] = this.$t('ER')

    this.csldReasonDesc[0] = this.$t('No leak').toUpperCase()
    this.csldReasonDesc[1] = this.$t('Leak detected').toUpperCase()
    this.csldReasonDesc[2] = this.$t('Code').toUpperCase() + ' 2'
    this.csldReasonDesc[3] = this.$t('Insufficient volume').toUpperCase()
    this.csldReasonDesc[4] = this.$t('Code').toUpperCase() + ' 4'
    this.csldReasonDesc[5] = this.$t('Code').toUpperCase() + ' 5'
    this.csldReasonDesc[6] = this.$t('Code').toUpperCase() + ' 6'
    this.csldReasonDesc[7] = this.$t('Code').toUpperCase() + ' 7'
    this.csldReasonDesc[8] = this.$t('Product gain during test').toUpperCase()
    this.csldReasonDesc[9] = this.$t('Code').toUpperCase() + ' 9'
    this.csldReasonDesc[10] = this.$t('Code').toUpperCase() + '10'
    this.csldReasonDesc[11] = this.$t('High leak rate variation').toUpperCase()
    this.csldReasonDesc[12] = this.$t('Bottom temperature deviation').toUpperCase()
    this.csldReasonDesc[13] = this.$t('Temperature noise').toUpperCase()
    this.csldReasonDesc[14] = this.$t('Product height noise').toUpperCase()
    this.csldReasonDesc[15] = this.$t('Invalid thermal expansion').toUpperCase()
    this.csldReasonDesc[16] = this.$t('Not enough segments').toUpperCase()
    this.csldReasonDesc[17] = this.$t('Calculation error').toUpperCase()
  },
  methods: {
    getText () {
      let result = this.$t('Height') + ' (' + this.Maglink.LevelFormat(this.tankData.maxLevel, this.systemSettings.levelUnit) + ')'
      result += ' ' + this.options.levelUnits[this.systemSettings.levelUnit || 0].desc + ' - '
      result += this.$t('Max volume') + ' (' + this.Maglink.VolumeFormat(this.tankData.maxVolume, this.systemSettings.volumeUnit) + ')'
      result += ' ' + this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

      return result
    },
    getTitle () {
      let result = this.tankData.tankDescription
      if (result === undefined) {
        result = this.$t('Tank {0}', [this.tankData.tankNumber])
      }
      result += ' (' + this.$t('Serial: {0}', [this.tankData.serial]) + ')'

      return result
    },
    snack (color, message) {
      message = 'CSLD: ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
